export function notifyResearchAccessChange(status: number | undefined, code: unknown): void {
  // Paket 11 (KOS-13): budget refusals (429 COST_LIMIT, 409 COST_UNCONFIGURED) refresh the access state as well.
  // Profil-Nachbau F-17 (PF-782, BAU-RECHT.md 3.2): so does 403 USAGE_POLICY_REQUIRED; checkAuth then shows the consent page.
  // Profil-Nachbau F-16 (PF-773, BAU-RECHT.md 2.3): and 403 AVV_REQUIRED, so „Mein Zugang“ names the missing AVV.
  if ((status === 403 || status === 409 || status === 429) && typeof code === 'string' &&
      ['SEAT_REQUIRED', 'PLATFORM_RESEARCH_BLOCKED', 'ORGANIZATION_BLOCKED', 'PAYMENT_OVERDUE', 'SUBSCRIPTION_EXPIRED', 'RESEARCH_LIMIT', 'TRIAL_LIMIT', 'COST_LIMIT', 'COST_UNCONFIGURED', 'USAGE_POLICY_REQUIRED', 'AVV_REQUIRED'].includes(code)) {
    window.dispatchEvent(new CustomEvent('auth:access-changed'));
  }
}
